import React, { useState } from 'react';
import { NIJ_BLOG_HTML } from './NijBlogContent';

// Temporary page: preview the blog HTML and copy it to the backend editor. Delete after use.
function NijBlogPreview() {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(NIJ_BLOG_HTML.trim());
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="blog-detail-blk pt-5 pb-100">
      <div className="container">
        <div className="d-flex justify-content-end mb-3">
          <button type="button" className="btn btn-danger" onClick={copy}>
            {copied ? 'Copied!' : 'Copy HTML'}
          </button>
        </div>
        <div dangerouslySetInnerHTML={{ __html: NIJ_BLOG_HTML }} />
      </div>
    </section>
  );
}

export default NijBlogPreview;
